import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
        

const MOVE_MIME = 'application/x-disbox-move';

// Tiap bagian breadcrumb juga jadi target drop: seret file/folder ke sini untuk
// memindahkannya ke folder itu (mis. ke "Storage" untuk mengeluarkan ke root).
function PathPart(props) {
    const [over, setOver] = useState(false);
    const isMoveDrag = (e) => e.dataTransfer && e.dataTransfer.types.includes(MOVE_MIME);
    return <div
        onDragOver={(e) => {
            if (!props.onMoveDrop || !isMoveDrag(e)) return;
            e.preventDefault();
            e.stopPropagation();
            e.dataTransfer.dropEffect = 'move';
            setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
            if (!props.onMoveDrop || !isMoveDrag(e)) return;
            e.preventDefault();
            e.stopPropagation();
            setOver(false);
            props.onMoveDrop(props.path);
        }}
        style={{
            flexShrink: 0,
            ...(over ? { outline: '2px dashed #1a90ff', outlineOffset: '-2px', borderRadius: '4px', backgroundColor: 'rgba(26, 144, 255, 0.15)' } : {}),
        }}
    >
        <Button onClick={() => props.showDirectory(props.path)}>{`${props.name} >`}</Button>
    </div>
}

export default function PathParts(props) {
    const [partComponents, setPartComponents] = useState([]);

    useEffect(() => {
        async function f() {
            if (!props.fileManager) {
                return;
            }
            const parts = [];
            if (props.path !== null) {
                if (props.path !== "") {
                    parts.push(<PathPart fileManager={props.fileManager} path={props.path}
                        name={await props.fileManager.getFile(props.path).name} showDirectory={props.showDirectory} onMoveDrop={props.onMoveDrop} />);
                }
                let parent = await props.fileManager.getParent(props.path);
                while (parent && "path" in parent) {
                    parts.push(<PathPart fileManager={props.fileManager} path={parent.path} name={parent.name} showDirectory={props.showDirectory} onMoveDrop={props.onMoveDrop} />);
                    parent = await props.fileManager.getParent(parent.path);
                }
            }
            parts.push(<PathPart fileManager={props.fileManager} path={""} name={"Storage"} showDirectory={props.showDirectory} onMoveDrop={props.onMoveDrop} />);
            setPartComponents(parts.reverse());

        }
        f();
    }, [props.path]);

    // Folder bersarang dalam bisa menghasilkan breadcrumb yang lebih lebar
    // dari layar HP - di-scroll horizontal di dalam baris ini sendiri saja,
    // bukan mendorong seluruh halaman melebar (yang bikin tampilan "aneh"/
    // terpotong di mobile).
    return <div style={{ display: "flex", overflowX: "auto", maxWidth: "100%" }}>
        {partComponents.map((component, index) => (
            <React.Fragment key={index}>
                {component}
            </React.Fragment>
        ))}
    </div>
}
